<template>
    <div style="background-color: #F8F9FB;">
        <hhead></hhead>
        <crm-nav></crm-nav>
        <div class="jgMsg_box">
            <div class="jgMsg" :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          minWidth: '1200px',
        }">
                <!-- <div class="select">
                    <el-select v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div> -->
                <!-- <div class="choiceAll" style="cursor: pointer;" >
                    <p @click ="reset">全部账号 ></p>
                    <li v-for="(item,index) in selVal" :key='index'>{{item.name}}：<span style="color: #5C85FF;">{{item.description}}</span> <i @click = "delBtn(item)" class="el-icon-close"></i> </li>
                </div> -->
                <!-- <li>年化收益：<span>5%-20%</span> <i class="el-icon-close"></i></li> -->
                <div v-show="openShow" class="addBtn inv" @click="open" style="margin-bottom: 0;float: right;">
                    查看更多 <i class="el-icon-arrow-down"></i>
                </div>
                <div v-show="!openShow" class="addBtn inv" @click="up" style="margin-bottom: 0;float: right;">
                    点击收起 <i class="el-icon-arrow-up"></i>
                </div>
                <div style="flex:1;display:flex;margin-bottom: 20px;margin-left: 0;" class="AZ">
                    <li v-show="listShow" :class="{liActive : active =='all'}" @click="mouseover1"
                        style="font-size: 14px;">全部</li>
                    <li v-show="listShow" :class="{liActive : active == item}" @click="mouseover(item)"
                        v-for="(item,index) in A_Z" :key="index" style="font-size: 14px;">{{item}}</li>


                </div>

                <!-- <div class="LogoBox" :style="{overflowY:overFlow,maxHeight:LogoHeight,minHeight:'59px',marginBottom:'30px'}">
                    <a :class="{li_active:simpleName==item.id}" @click = 'colorActive(item.simpleName,item.id)'  v-for = "(item,index) in listArr">

                        <img style="width: 100px;height: 53px;margin-top: 4px;" v-if ='item.selfImage&& item.type==0' :src="api + item.selfImage" alt="">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <img style="width: 26px;height: 26px;border-radius: 50%;margin-right: 10px;" v-if ='item.selfImage&& item.type==1' :src="api + item.selfImage" alt="">
                            <span>{{item.simpleName}}</span>
                        </div>
                        <span v-if ='!item.selfImage'>{{item.simpleName}}</span>
                        <p>{{item.simpleName}}</p>
                    </a>             
                </div> -->


                <div class="LogoBox"
                    :style="{overflowY:overFlow,maxHeight:LogoHeight,minHeight:'59px',marginBottom:'30px'}">
                    <a v-for="(item, index) in listArr" @click="
                        invClick(item.id, item.simpleName, item.selected, index)
                      " :class="{ li_active: item.selected }">
                        <img style="width: 100px;height: 53px;margin-top: 4px;" v-if="item.selfImage && item.type == 0"
                            :src="api + item.selfImage" alt="" />
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <img style="width: 26px;height: 26px;border-radius: 50%;margin-right: 10px;"
                                v-if="item.selfImage && item.type == 1" :src="api + item.selfImage" alt="" />
                            <span>{{ item.simpleName }}</span>
                        </div>
                        <span v-if="!item.selfImage">{{ item.simpleName }}</span>
                        <p>{{ item.simpleName }}</p>
                        <i v-show="item.selected"
                            style="font-size: 18px;position: absolute;color: #5B85FF;z-index: 100;top: -24px;right: -5px;"
                            class="iconfont icon-dui"></i>
                    </a>
                </div>





                <div class="analysisBox">
                    <p style="margin-right: 25px;">投资策略：</p>

                    <p @click="cl(item.name,item.value,index)" :class="{active__ : item.selected}"
                        style="height: 26px;padding: 0 17px;border: 1px solid #C3C7CD;border-radius: 4px;position: relative;overflow: hidden;"
                        v-for="(item,index) in strategy" :key=index>{{item.name}} <i class="iconfont icon-dui"
                            style="position: absolute;color: #C3C7CD !important;right: -3px;top: -7px;font-size: 14px;z-index: 100;"></i>
                    </p>

                </div>


                <div class="analysisBox" v-show='YearlyProfitRateRShow'>
                    <p style="line-height: 26px;margin-right: 10px;width: 85px;">
                        {{dataList.YearlyProfitRateR.typeName}}：</p>

                    <p @click="selected(item,index)" :class="{active__ : item.selected,pHover:true}"
                        style="width: 100px;border: 1px solid #E7E7E7;border-radius: 2px;text-align: center;"
                        v-for="(item,index) in dataList.YearlyProfitRateR.conditions" :key=index>{{item.description}}
                    </p>
                </div>



                <div class="analysisBox" v-show='NetShow'>
                    <p style="line-height: 26px;margin-right: 10px;width: 85px;">{{dataList.Net.typeName}}：</p>

                    <p @click="selected3(item,index)" :class="{active__ : item.selected,pHover:true}"
                        style="width: 100px;border: 1px solid #E7E7E7;border-radius: 2px;text-align: center;"
                        v-for="(item,index) in dataList.Net.conditions" :key=index>{{item.description}}</p>

                </div>

                <div class="analysisBox" style="margin-bottom: 50px;"
                    v-show='RevenueCycleShow||MaxLossShow||SharpeRateShow||SortinoRateShow||CalmarRateShow||YearlyWaveShow'>
                    <p style="line-height: 26px;margin-right: 10px;width: 85px;">高级选项：</p>

                    <!-- 资金规模 -->
                    <p class="Advanced"
                    @click="scaleBtnDel"
                        :style="{color:scaleText!='规模范围'?'#fff':'',borderColor:scaleText!='规模范围'?'#5b85ff':'',background:scaleText!='规模范围'?'#5b85ff':''}"
                        v-show='scaleShow'>{{scaleText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>
                            <li @click.stop="scaleBtn(item,index)" :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}" v-for="(item,index) in moenyList" :key='index'>
                                {{item.name}}</li>
                        </span>

                    </p>



                    <!-- 收益周期 -->
                    <p class="Advanced"
                    @click = 'RevenueCycleBtnDel'
                        :style="{color:profitText!='收益周期'?'#fff':'',borderColor:profitText!='收益周期'?'#5b85ff':'',background:profitText!='收益周期'?'#5b85ff':''}"
                        v-show='RevenueCycleShow'>{{profitText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>

                            <li @click.stop="RevenueCycleBtn(item,index)"
                            :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}"
                                v-for="(item,index) in dataList.RevenueCycle.conditions" :key='index'>
                                {{item.description}}</li>
                        </span>

                    </p>

                    <!-- 最大回撤 -->
                    <p class="Advanced"
                    @click="MaxLossBtnDel"
                        :style="{color:MaxLossText!='最大回撤'?'#fff':'',borderColor:MaxLossText!='最大回撤'?'#5b85ff':'',background:MaxLossText!='最大回撤'?'#5b85ff':''}"
                        v-show='MaxLossShow'>{{MaxLossText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>
                            <li @click.stop="MaxLossBtn(item,index)" v-for="(item,index) in dataList.MaxLoss.conditions"
                            :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}"
                                :key='index'>{{item.description}}</li>
                        </span>
                    </p>

                    <!-- 夏普比率 -->
                    <p class="Advanced"
                    @click="SharpeRateBtnDel"
                        :style="{color:SharpeRateText!='夏普比率'?'#fff':'',borderColor:SharpeRateText!='夏普比率'?'#5b85ff':'',background:SharpeRateText!='夏普比率'?'#5b85ff':''}"
                        v-show='SharpeRateShow'>{{SharpeRateText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>
                            <li @click.stop="SharpeRateBtn(item,index)"
                            :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}"
                                v-for="(item,index) in dataList.SharpeRate.conditions" :key='index'>{{item.description}}
                            </li>
                        </span>
                    </p>

                    <!-- 索提诺比率 -->
                    <p class="Advanced"
                    @click = "SortinoRateBtnDel"
                        :style="{color:SortinoRateText!='索提诺比率'?'#fff':'',borderColor:SortinoRateText!='索提诺比率'?'#5b85ff':'',background:SortinoRateText!='索提诺比率'?'#5b85ff':''}"
                        v-show='SortinoRateShow'>{{SortinoRateText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>
                            <li @click.stop="SortinoRateBtn(item,index)"
                            :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}"
                                v-for="(item,index) in dataList.SortinoRate.conditions" :key='index'>
                                {{item.description}}</li>
                        </span>
                    </p>

                    <!-- 卡玛比率 -->
                    <p class="Advanced"
                    @click = "CalmarRateBtnDel"
                        :style="{color:CalmarRateText!='卡玛比率'?'#fff':'',borderColor:CalmarRateText!='卡玛比率'?'#5b85ff':'',background:CalmarRateText!='卡玛比率'?'#5b85ff':''}"
                        v-show='CalmarRateShow'>{{CalmarRateText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>
                            <li @click.stop="CalmarRateBtn(item,index)"
                            :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}"
                                v-for="(item,index) in dataList.CalmarRate.conditions" :key='index'>{{item.description}}
                            </li>
                        </span>
                    </p>

                    <!-- 年化波动 -->
                    <p class="Advanced"
                    @click = "YearlyWaveBtnDel"
                        :style="{color:YearlyWaveText!='年化波动'?'#fff':'',borderColor:YearlyWaveText!='年化波动'?'#5b85ff':'',background:YearlyWaveText!='年化波动'?'#5b85ff':''}"
                        v-show='YearlyWaveShow'>{{YearlyWaveText}} <i class="el-icon-arrow-down"></i> <i
                            class="el-icon-arrow-up"></i>
                        <i class="hr"
                            style="width: 100px;height: 1px;background: #fff;display: block;position: relative;z-index: 999;display: none;"></i>
                        <span>
                            <li @click.stop="YearlyWaveBtn(item,index)"
                            :style="{color:item.selected?'#5b85ff':'',background:item.selected?'#ecf2ff':''}"
                                v-for="(item,index) in dataList.YearlyWave.conditions" :key='index'>{{item.description}}
                            </li>
                        </span>
                    </p>

                    <h2 v-if='!adLevel' @click="editBtn" class="search1" style="cursor: pointer;
                width: 80px;
                height: 32px;   
                text-align: center;
                box-sizing: border-box;
                border: 0;
                background-color: #fff;
                border: 1px solid #5b85ff;
                
                font-size: 14px;
               margin-top: -4px;
                color: #5b85ff;
                line-height: 32px;
                border-radius: 2px;">自定义</h2>
                </div>


                <div class="table tableChecked">
                    <el-table :data="res" :header-cell-style="{textAlign: 'center'}" border size="medium"
                        :default-sort="{prop: 'date', order: 'descending'}">

                        <el-table-column prop="userName" :render-header="renderHeader" align="center" width="50">
                            <template slot-scope="scope">
                                <el-checkbox @change="checkBtn(scope.row.deleted)" v-model="scope.row.deleted">
                                </el-checkbox>
                            </template>

                        </el-table-column>
                        <el-table-column prop="userCode" align="center" label="账户">
                        </el-table-column>
                        <el-table-column prop="userName" align="center" label="姓名" width="">
                        </el-table-column>


                        <el-table-column prop="sumNet" width="100" sortable align="right" label="净值">
                            <template slot-scope="scope">
                                <span :style="{color:scope.row.sumNet>1?'#FA5D22':'#3ABA94'}">
                                    {{scope.row.sumNet|num3}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisYearProfit" width="90" sortable align='right' label="今年来">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.thisYearProfit>=0?'#FA5D22':'#3ABA94'}">{{scope.row.thisYearProfit|num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisMonthProfit" width="90" sortable align='right' label="月内">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.thisMonthProfit>=0?'#FA5D22':'#3ABA94'}">{{scope.row.thisMonthProfit|num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="profitRate" width="100" sortable align="right" label="累计">
                            <template slot-scope="scope">
                                <span :style="{color:scope.row.profitRate>=0?'#FA5D22':'#3ABA94'}">
                                    {{scope.row.profitRate|num}}
                                </span>
                            </template>
                        </el-table-column>
                        </el-table-column>




                        <el-table-column prop="maxLoss" width="120" sortable align="right" label="最大回撤">
                            <template slot-scope="scope">
                                <span :style="{color:scope.row.maxLoss>=0?'#FA5D22':'#3ABA94'}">
                                    {{scope.row.maxLoss|num}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sharpeRate" width="120" sortable align="right" label="夏普比率">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.sharpeRate|num1}}
                                </span>
                            </template>

                        </el-table-column>

                        <el-table-column prop="sharpeRate" width="120" sortable align="right" label="卡玛比率">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.calmarRate|num1}}
                                </span>
                            </template>

                        </el-table-column>

                        <el-table-column prop="sumNet" width="100" sortable align="right" label="年化">
                            <template slot-scope="scope">
                                <span :style="{color:scope.row.yearlyProfitRate>0?'#FA5D22':'#3ABA94'}">
                                    {{scope.row.yearlyProfitRate|num}}
                                </span>
                            </template>
                        </el-table-column>


                        <el-table-column prop="sortinoRate" width="120" sortable align="right" label="索提诺比例">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.sortinoRate|num1}}
                                </span>
                            </template>

                        </el-table-column>


                        <el-table-column prop="yearlyWave" width="110" sortable align="right" label="年化波动">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.yearlyWave|num}}
                                </span>
                            </template>

                        </el-table-column>
                    </el-table>
                </div>
                <p style="margin: 10px 0;font-size: 14px;">已选择{{count}}个</p>
                <div @click="analysis" :style="{cursor: 'pointer',background:count?'#5b85ff':'#C2C7CE',
                width: '100px',
                height: '32px',
                textAlign: 'center',
                boxSizing: 'border-box',
                border: 0,
                lineHeight: '32px',             
                fontSize: '16px',
                marginRight: '20px',
                color: '#fff',
                borderRadius: '2px'
            }">点击分析</div>


                <!-- <div class="page_box">
                    <div class="msg_count">共&nbsp;{{ length?length:'0' }}&nbsp;条</div>
                    <div class="blank"></div>
                    <div class="page">
                      <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pageLength ? pageLength : 0"
                       
                        @current-change="currentPage"
                      >
                      </el-pagination>
                    </div>
                </div> -->

            </div>
        </div>
        <transition name="el-fade-in-linear">
            <!--  编辑 -->
            <div class="popContainer" v-show="editShow" style="overflow: auto;">
                <div class="add" :style="{ width: '1200px',paddingBottom:'20px' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '1200px' }">
                        编辑
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
                     " @click='saveBtn'></span>
                    <div class="form_box" style="width: 100%;padding: 30px 30px 10px;">
                        <div class="form" style="display: block;">

                            <!-- 年化收益 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.YearlyProfitRateR.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.YearlyProfitRateR.conditions"
                                        :key=index>{{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.YearlyProfitRateR.conditions.length<8">
                                        <el-input v-model='YearMin' type="number" placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input v-model='YearMax' type="number" placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:YearMin||YearMax?'#fff':'',background:YearMin||YearMax?'#5C85FF':''}"
                                            @click='YearBtn'>保存</li>
                                    </div>

                                </div>
                            </div>

                            <!-- 净值 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.Net.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.Net.conditions" :key=index>
                                        {{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.Net.conditions.length<8">
                                        <el-input type="number" v-model='NetMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='NetMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:NetMin||NetMax?'#fff':'',background:NetMin||NetMax?'#5C85FF':''}"
                                            @click='NetBtn'>保存</li>
                                    </div>

                                </div>
                            </div>

                            <!-- 收益周期 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.RevenueCycle.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.RevenueCycle.conditions"
                                        :key=index>{{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.RevenueCycle.conditions.length<8">
                                        <el-input type="number" v-model='RevenueCycleMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='RevenueCycleMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:RevenueCycleMin||RevenueCycleMax?'#fff':'',background:RevenueCycleMin||RevenueCycleMax?'#5C85FF':''}"
                                            @click='RevenueCycleBtn_'>保存</li>
                                    </div>

                                </div>
                            </div>


                            <!-- 最大回撤 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.MaxLoss.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.MaxLoss.conditions" :key=index>
                                        {{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.MaxLoss.conditions.length<8">
                                        <el-input type="number" v-model='MaxLossMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='MaxLossMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:MaxLossMin||MaxLossMax?'#fff':'',background:MaxLossMin||MaxLossMax?'#5C85FF':''}"
                                            @click='MaxLossBtn_'>保存</li>
                                    </div>

                                </div>
                            </div>

                            <!-- 夏普比率 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.SharpeRate.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.SharpeRate.conditions"
                                        :key=index>{{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.SharpeRate.conditions.length<8">
                                        <el-input type="number" v-model='SharpeRateMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='SharpeRateMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:SharpeRateMin||SharpeRateMax?'#fff':'',background:SharpeRateMin||SharpeRateMax?'#5C85FF':''}"
                                            @click='SharpeRateBtn_'>保存</li>
                                    </div>

                                </div>
                            </div>

                            <!-- 索提诺比率 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.SortinoRate.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.SortinoRate.conditions"
                                        :key=index>{{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.SortinoRate.conditions.length<8">
                                        <el-input type="number" v-model='SortinoRateMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='SortinoRateMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:SortinoRateMin||SortinoRateMax?'#fff':'',background:SortinoRateMin||SortinoRateMax?'#5C85FF':''}"
                                            @click='SortinoRateBtn_'>保存</li>
                                    </div>

                                </div>
                            </div>

                            <!-- 卡 玛 比 率 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.CalmarRate.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.CalmarRate.conditions"
                                        :key=index>{{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.CalmarRate.conditions.length<8">
                                        <el-input type="number" v-model='CalmarRateMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='CalmarRateMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:CalmarRateMin||CalmarRateMax?'#fff':'',background:CalmarRateMin||CalmarRateMax?'#5C85FF':''}"
                                            @click='CalmarRateBtn_'>保存</li>
                                    </div>

                                </div>
                            </div>

                            <!-- 年化波动 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"
                                    style="flex: none;margin-top: 0;font-size: 14px;color: #181E2D;width: 90px;padding-right: 0;text-align: right;">
                                    {{dataList.YearlyWave.typeName}}：</div>
                                <div class="right" style="display: flex;">
                                    <p class="editStyle" v-for="(item,index) in dataList.YearlyWave.conditions"
                                        :key=index>{{item.description}}
                                        <i class="el-icon-error" @click='removeBtn(item)'></i>
                                    </p>
                                    <div class="editInput" v-show="dataList.YearlyWave.conditions.length<8">
                                        <el-input type="number" v-model='YearlyWaveMin' placeholder=""></el-input>
                                        <span>—</span>
                                        <el-input type="number" v-model='YearlyWaveMax' placeholder=""></el-input>
                                        <li class="editSaveBtn"
                                            :style="{color:YearlyWaveMin||YearlyWaveMax?'#fff':'',background:YearlyWaveMin||YearlyWaveMax?'#5C85FF':''}"
                                            @click='YearlyWaveBtn_'>保存</li>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form_btn">
                        <button @click='saveBtn'>提交</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>







    </div>
</template>
<script>
    import hhead from '../header/index';
    import crmNav from '../../../components/crmNav/index';
    import './style.css';
    export default {
        components: { hhead, crmNav },
        data() {
            return {
                scaleText: '规模范围',
                profitText: '收益周期',
                MaxLossText: '最大回撤',
                SharpeRateText: '夏普比率',
                SortinoRateText: '索提诺比率',
                CalmarRateText: '卡玛比率',
                YearlyWaveText: '年化波动',
                YearMin: '',//年化收益起始
                YearMax: '',//年化收益最大值
                NetMin: '',//净值min
                NetMax: '',//净值max
                RevenueCycleMin: '',//收益周期min
                RevenueCycleMax: '',//收益周期max
                MaxLossMin: '',//回撤min
                MaxLossMax: '',//回撤max
                SharpeRateMin: '',//夏普比率min
                SharpeRateMax: '',//夏普比率max
                SortinoRateMin: '',//索提诺比率min
                SortinoRateMax: '',//索提诺比率max
                CalmarRateMin: '',//卡 玛 比 率min
                CalmarRateMax: '',//卡 玛 比 率max
                YearlyWaveMin: '',//年化波动min
                YearlyWaveMax: '',//年化波动max
                AZ: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
                A_Z: [],
                dataList: {
                    YearlyProfitRateR: { conditions: [] },//年化收益
                    YearlyWave: { conditions: [] },//年化波动
                    SortinoRate: { conditions: [] },//索提诺比率
                    SharpeRate: { conditions: [] },//夏普比率
                    RevenueCycle: { conditions: [] },//收益周期
                    Net: { conditions: [] },//净值
                    MaxLoss: { conditions: [] },//最大回撤
                    CalmarRate: { conditions: [] },//卡玛比率
                },//所有类型数据

                YearlyProfitRateRShow: true,
                YearlyWaveShow: true,//年化波动
                SortinoRateShow: true,//索提诺比率
                SharpeRateShow: true,//夏普比率
                RevenueCycleShow: true,//收益周期
                NetShow: true,//净值
                MaxLossShow: true,//最大回撤
                CalmarRateShow: true,//卡玛比率
                scaleShow: true,//资金规模

                editShow: false,//控制编辑显示隐藏
                selVal: [],//已篩選的類型
                investorId: '',//投顾id
                listShow: false,
                simpleName: '',
                list_: [],

                overFlow: 'hidden',
                LogoHeight: '59px',
                listArr: [],
                openShow: true,
                active: 'all',//字母class名
                count: 0,
                MHeight: document.documentElement.clientHeight - 94 + 'px',
                res: [],//数据列表
                options: [],//选择投顾列表
                value: '',//选择投顾的值
                strategy: [],//策略列表
                clVal: '',//策略值
                syVal: '',//收益
                cl_active: '',
                sy_active: '',
                active: '',//样式
                active2: '',//样式
                active3: '',//样式
                active4: '',//样式
                active5: '',//样式
                active6: '',//样式
                active7: '',//样式
                active8: '',//样式
                active9: '',//样式
                yearlyProfitRateL: '',//年化收益起始值
                yearlyProfitRateR: '',//年化收益临界值
                maxLossL: '',//最大回撤起始值
                maxLossR: '',//最大回撤临界值
                netL: '',//净值起始值
                netR: '',//净值临界值
                sharpeRateL: '',//夏普起始值
                sharpeRateR: '',//夏普临界值
                sortinoRateL: '',//索提诺起始值
                sortinoRateR: '',//索提诺临界值

                yearlyWaveL: '',//年化波动起始值
                yearlyWaveR: '',//年化波动临界值
                kamaL: '',//卡玛起始值
                kamaR: '',//卡玛临界值
                scale: '',//规模
                logLevel: false,
                length: '',
                moenyList: '',
                api: this.$store.state.api,
                adLevel: '',
                activeList: [], //已选中投顾
            };
        },
        filters: {
            datas: function (date) {
                return date.substr(0, 10).replace(/\//g, '-')
            },
            num: function (n) { //数字格式化
                return (Math.round(n * 10000) / 100).toFixed(2) + '%'
            },
            num1: function (n) {
                if (n) {

                    return (Math.round(n * 100) / 100).toFixed(2)
                } else {
                    return '0.00'
                }
            },
            num3: function (n) {
                if (n) {
                    return n.toFixed(4)
                }
            },
        },

        mounted() {
            this.adLevel = JSON.parse(localStorage.getItem('res')).adLevel //是否是超管 0=超管
            //   console.log(this.adLevel)
            this.axiosList()

            this.saveList()



            this.$axios.post( //投顾列表
                '/crm/inverstor/queryAllInverstor',
                { apiToken: this.$store.state.usermsg.apiToken }
            ).then(res => {
                // console.log(res)
                if (res.data.code == 200) {
                    this.options = res.data.data
                }
            })

            this.$axios.post( //策略列表
                '/crm/acc/queryStrategyType',
                { apiToken: this.$store.state.usermsg.apiToken }
            ).then(res => {
                // console.log(res)
                if (res.data.code == 200) {
                    this.strategy = res.data.data
                }
            })

            this.$axios.post( //初始规模
                '/crm/acc/queryInitBalance',
                { apiToken: this.$store.state.usermsg.apiToken, }
            ).then(res => {
                // console.log(res)
                if (res.data.code == 200) {
                    this.moenyList = res.data.data
                }
            })

            this.pagiAxios()



        },
        methods: {
            formatter(row, column) { //表格排序
                return row.address;
            },
            /** 表头增加复选框 */
            renderHeader(h, { column }) {
                return (
                    'span',
                    [
                        h('el-checkbox', {
                            on: {
                                change: this.select
                            },
                            props: {
                                value: this.logLevel //文字框的内容取决于这个value，如果value不存在，会报错
                            }
                        }),
                        h('span', column.label)
                    ]
                )
            },
            editBtn() {//编辑按钮
                this.editShow = true
            },
            closeBtn() {//关闭编辑浮层
                this.editShow = false
            },
            reset() {
                window.location.reload()
            },
            saveList() {
                this.$axios.post( //条件类型
                    '/crm/acc_date/querySearchCondition',
                    { apiToken: this.$store.state.usermsg.apiToken }
                ).then(res => {
                    // console.log(res)
                    if (res.data.code == 200) {

                        this.dataList = res.data.data
                    }

                })
            },
            invClick(id, name, selected, i) {
                //控制多选投顾标签
                if (this.listArr[i].selected) {
                    this.activeList.forEach((item, index) => {
                        if (item.id == id) {
                            this.activeList.splice(index, 1);
                        }
                    });
                } else {
                    this.activeList.push({ id: id, name: name, checked: true });
                }
                this.listArr[i].selected = !selected;
                var invID = ''
                this.listArr.forEach(item => {
                    if (item.selected) {
                        invID = invID + ',' + item.id
                    }
                })
                this.investorId = invID
                this.search()
                //   console.log(this.activeList);
            },

            // invClick(name,id){
            //     if(this.simpleName == id){
            //         this.simpleName = ''
            //         this.investorId = ''
            //     }else{
            //         this.simpleName = id
            //         this.investorId = id
            //     }
            //     this.search()

            // },
            inpBlur() {
                this.search()
            },
            /** 是否勾选表头 */
            select(checked) {
                // 如果checked为true则是勾选了对应的表头
                //   console.log(checked)
                this.logLevel = checked
                if (checked) {
                    this.res.forEach((item, index) => {
                        item.deleted = true

                    })
                    this.count = this.res.length
                } else {
                    this.res.forEach(item => {
                        item.deleted = false
                        this.count = 0
                    })
                }
            },

            analysis() { //分析
                let arrId = ''
                this.res.forEach(item => {
                    if (item.deleted) {

                        arrId += ',' + item.id
                    }
                })
                if (this.count) {
                    window.open('_blank').location.href = `/crm/analysis/Fitting?id=${arrId.replace(',', '')}`

                } else {
                    this.$alert('请选择账户进行分析', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
                }
            },
            checkBtn(e) {
                e = true
                let num = 0
                this.res.forEach(item => {
                    if (item.deleted) {
                        num++
                    } else {
                        this.logLevel = false
                    }
                })
                this.count = num


                // console.log(this.res)
            },
            mouseover(e) {
                //字母点击事件
                this.active = e
                let arr = []
                let pinyin = require('js-pinyin');
                pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
                this.list_.forEach(item => {
                    if (e == pinyin.getFullChars(item.simpleName).substr(0, 1)) {
                        arr.push(item)
                    }
                })
                this.listArr = arr

            },
            mouseover1() {
                this.active = 'all'
                this.listArr = this.list_

            },
            axiosList() { //请求列表
                this.$axios
                    .post('/crm/inverstor/queryAllInverstor', {
                        apiToken: this.$store.state.usermsg.apiToken,
                    })
                    .then((res) => {
                        // console.log(res);
                        // this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            let arr = []
                            let pinyin = require('js-pinyin');
                            pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
                            res.data.data.forEach(item => {
                                arr.push(pinyin.getFullChars(item.simpleName).substr(0, 1))
                            })
                            // console.log(arr)
                            let str = ''
                            arr.forEach((e) => {
                                if (str.indexOf(e) < 0) {
                                    str += e.toUpperCase()

                                }
                            })
                            this.A_Z = str.split('')


                            this.list_ = res.data.data
                            this.listArr = this.list_
                        }
                    });
            },
            search() {
                this.pagiAxios()
            },
            open() {
                this.overFlow = 'scroll'
                this.LogoHeight = '177px'
                this.openShow = false
                this.listShow = true
            },
            up() {
                this.openShow = true
                this.LogoHeight = '59px'
                this.overFlow = 'hidden'
                this.listShow = false
                this.listArr = this.list_
            },

            pagiAxios() {

                this.clVal = ''
                this.strategy.forEach(item => {
                    if (item.selected) {
                        this.clVal += ',' + item.value
                    }
                })
                let obj = {
                    investorIds: this.investorId.replace(',', ''),
                    apiToken: this.$store.state.usermsg.apiToken,
                    strategyTypes: this.clVal.replace(',', ''),
                    page_no: 1,
                    size: 1000,
                    isEdit: true
                }
                this.selVal.forEach(item => {
                    if (item.type == 20051) {
                        obj.yearlyProfitRateR = item.max
                        obj.yearlyProfitRateL = item.min
                    } else if (item.type == 20052) {
                        obj.netR = item.max
                        obj.netL = item.min
                    } else if (item.type == 20053) {
                        obj.RevenueCycleR = item.max
                        obj.RevenueCycleL = item.min
                    } else if (item.type == 20054) {
                        obj.maxLossR = item.max
                        obj.maxLossL = item.min
                    } else if (item.type == 20055) {
                        obj.sharpeRateR = item.max
                        obj.sharpeRateL = item.min
                    } else if (item.type == 20056) {
                        obj.sortinoRateR = item.max
                        obj.sortinoRateL = item.min
                    } else if (item.type == 20057) {
                        obj.calmarRateR = item.max
                        obj.calmarRateL = item.min
                    } else if (item.type == 20058) {
                        obj.yearlyWaveR = item.max
                        obj.yearlyWaveL = item.min
                    } else if (item.type == 20059) {
                        obj.capitalScale = item.value
                    }
                })



                this.$axios.post(
                    '/crm/acc_date/searchAcc',
                    obj
                ).then(res => {
                    // console.log(res)
                    if (res.data.code == 200) {
                        this.logLevel = false
                        this.count = 0
                        this.res = res.data.data
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            check(check) {
                check = !check
                // console.log(this.strategy)

            },
            cl(name, val, index) { //策略
                // this.clVal = val
                this.cl_active = ''


                if (this.strategy[index].selected) {
                    this.strategy[index].selected = false
                } else {
                    this.strategy[index].selected = true
                }
                this.pagiAxios()
            },
            cl_() { //策略
                this.clVal = ''
                this.cl_active = ''
                this.strategy.forEach(item => {
                    item.selected = false
                })
                this.pagiAxios()
            },

            selected(e, i) { //年化收益：

                e.name = '年化收益'

                if (!e.selected) {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20051) {
                            this.selVal.splice(index, 1)
                        }
                    })

                    this.dataList.YearlyProfitRateR.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20051) {
                            this.selVal.splice(index, 1)
                        }
                    })

                }
                // this.YearlyProfitRateRShow = false
                // console.log(this.selVal)
                this.search()
            },
            selected3(e, i) {//净值
                console.log(this.selVal)
                e.name = '净值'
                // this.NetShow = false
                // this.selVal.push(e)
                if (e.selected) {
                    e.selected = false
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20052) {
                            this.selVal.splice(index, 1)
                        }
                    })

                } else {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20052) {
                            this.selVal.splice(index, 1)
                        }
                    })
                   
                    this.dataList.Net.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == 20052) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.selVal.push(e)

                }
                this.search()
            },
            scaleBtn(e, i) {//资金规模
                console.log(e)
                if (e.selected) {

                    e.selected = false
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20059) {
                            this.selVal.splice(index, 1)
                            this.scaleText = '规模范围'
                        }
                    })

                } else {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20059) {
                           this.moenyList.forEach(e=>{
                               if(item.value == e.value){
                                   e.selected= false
                               }
                               
                           })
                            this.selVal.splice(index, 1)
                          
                        }
                    })

                    var obj = {}
                    e.selected = true
                    obj.type = 20059
                    obj.name = '规模范围'
                    this.scaleText = '规模' + e.name
                    obj.description = e.name
                    obj.value = e.value
                    // this.scaleShow = false
                    this.selVal.push(obj)
                }



                // console.log(obj)
                this.search()
            },
            scaleBtnDel(){
                this.moenyList.forEach(item=>{
                    item.selected = false
                })
                this.selVal.forEach((item, index) => {
                        if (item.type == 20059) {
                            this.selVal.splice(index, 1)
                            this.scaleText = '规模范围'
                        }
                    })
                    this.search()
            },
            RevenueCycleBtn(e, i) {//收益周期
                console.log(e)
                if (!e.selected) {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20053) {
                            this.selVal.splice(index, 1)
                        }
                    })

                    this.dataList.RevenueCycle.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.profitText = '收益周期' + e.description
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.profitText = '收益周期'
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20053) {
                            this.selVal.splice(index, 1)
                        }
                    })

                }



                e.name = '收益周期'
                // this.RevenueCycleShow = false
                // this.selVal.push(e)
                this.search()
            },
            RevenueCycleBtnDel(){
                this.dataList.RevenueCycle.conditions.forEach(item=>{
                    item.selected = false
                })
                this.selVal.forEach((item, index) => {
                        if (item.type == 20053) {
                            this.selVal.splice(index, 1)
                            this.profitText = '收益周期'
                        }
                    })
                    this.search()
            },
            MaxLossBtn(e, i) { //最大回撤：
                console.log(e)
                if (!e.selected) {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20054) {
                            this.selVal.splice(index, 1)
                        }
                    })

                    this.dataList.MaxLoss.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.MaxLossText = '最大回撤' + e.description
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.MaxLossText = '最大回撤'
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20054) {
                            this.selVal.splice(index, 1)
                        }
                    })

                }

                e.name = '最大回撤'
                // this.MaxLossShow = false

                this.search()
            },
            MaxLossBtnDel(){
                this.dataList.MaxLoss.conditions.forEach((item, index) => {
                       item.selected = false
                    })
                this.selVal.forEach((item, index) => {
                        if (item.type == 20054) {
                            this.selVal.splice(index, 1)
                        }
                    })
                    this.MaxLossText = '最大回撤'
                    this.search()

            },
            SharpeRateBtn(e, i) {//夏普比率
                console.log(e)
                if (!e.selected) {
                    this.selVal.forEach((item, index) => {

                        if (item.type == 20055) {
                            this.selVal.splice(index, 1)
                        }
                        })

                    this.dataList.SharpeRate.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.SharpeRateText = '夏普' + e.description
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.SharpeRateText = '夏普比率'
                    this.selVal.forEach((item, index) => {

                        if (item.type == 20055) {
                            this.selVal.splice(index, 1)
                        }
                    })
              

                }
                e.name = '夏普比率'
                // this.SharpeRateShow = false
                // this.selVal.push(e)
                this.search()
            },
            SharpeRateBtnDel(){
                this.dataList.SharpeRate.conditions.forEach((item, index) => {
                       item.selected = false
                    })
                this.selVal.forEach((item, index) => {

                if (item.type == 20055) {
                    this.selVal.splice(index, 1)
                }
                })
                this.SharpeRateText = '夏普比率'
                this.search()

            },
            SortinoRateBtn(e, i) {//索提诺比率

                if (!e.selected) {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20056) {
                            this.selVal.splice(index, 1)
                        }
                    })
                    console.log(e)
                    this.dataList.SortinoRate.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.SortinoRateText = '索提诺' + e.description
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.SortinoRateText = '索提诺比率'
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20056) {
                            this.selVal.splice(index, 1)
                        }
                    })

                }
                e.name = '索提诺比率'
                // this.SortinoRateShow = false
                // this.selVal.push(e)
                this.search()
            },
            SortinoRateBtnDel(){
                this.dataList.SortinoRate.conditions.forEach((item, index) => {
                        item.selected = false
                    })
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20056) {
                            this.selVal.splice(index, 1)
                        }
                    })
                this.SortinoRateText = '索提诺比率'
                this.search()
            },

            CalmarRateBtn(e, i) {//卡玛
                console.log(e)
                if (!e.selected) {
                    this.selVal.forEach((item, index) => {
                        if (item.type == e.type) {
                            this.selVal.splice(index, 1)
                        }
                    })

                    this.dataList.CalmarRate.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.CalmarRateText = '卡玛' + e.description
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.CalmarRateText = '卡玛比率'
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20057) {
                            this.selVal.splice(index, 1)
                        }
                    })

                }
                e.name = '卡玛比率'
                // this.CalmarRateShow = false
                // this.selVal.push(e)
                this.search()
            },
            CalmarRateBtnDel(){
                this.dataList.CalmarRate.conditions.forEach((item, index) => {
                        item.selected = false
                    })
               
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20057) {
                            this.selVal.splice(index, 1)
                        }
                    })
                     this.CalmarRateText = '卡玛比率'
                this.search()
            },
            YearlyWaveBtn(e, i) {// 年化波动

                if (!e.selected) {
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20058) {
                            this.selVal.splice(index, 1)
                        }
                    })

                    this.dataList.YearlyWave.conditions.forEach((item, index) => {
                        if (index != i) {
                            item.selected = false
                        }
                        if (item.type == e.type) {
                            // this.selVal.splice(index,1)
                        }
                    })
                    e.selected = true
                    this.YearlyWaveText = '年化波动' + e.description
                    this.selVal.push(e)
                } else {
                    e.selected = false
                    this.YearlyWaveText = '年化波动'
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20058) {
                            this.selVal.splice(index, 1)
                        }
                    })

                }
                e.name = '年化波动'
                // this.YearlyWaveShow = false
                // this.selVal.push(e)
                this.search()
            },
            YearlyWaveBtnDel(){
                this.dataList.YearlyWave.conditions.forEach((item, index) => {
                       item.selected = false
                    })
                    this.selVal.forEach((item, index) => {
                        if (item.type == 20058) {
                            this.selVal.splice(index, 1)
                        }
                    })
                this.YearlyWaveText = '年化波动'
                this.search()
            },
            delBtn(e) {//删除筛选
                // console.log(e)
                if (e.type == 20051) {
                    this.YearlyProfitRateRShow = true
                } else if (e.type == 20052) {
                    this.NetShow = true
                } else if (e.type == 20053) {
                    this.RevenueCycleShow = true
                } else if (e.type == 20054) {
                    this.MaxLossShow = true
                } else if (e.type == 20055) {
                    this.SharpeRateShow = true
                } else if (e.type == 20056) {
                    this.SortinoRateShow = true
                } else if (e.type == 20057) {
                    this.CalmarRateShow = true
                } else if (e.type == 20058) {
                    this.YearlyWaveShow = true
                } else if (e.type == 20059) {
                    this.scaleShow = true
                }
                this.selVal.forEach((item, index) => {
                    if (item.type == e.type) {
                        this.selVal.splice(index, 1)
                    }
                })
                this.search()
            },
            YearBtn() {//年化收益保存按钮
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20051,
                        min: this.YearMin,
                        max: this.YearMax

                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.YearMin = ''
                        this.YearMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            NetBtn() {//净值保存按钮
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20052,
                        min: this.NetMin,
                        max: this.NetMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.NetMin = ''
                        this.NetMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            RevenueCycleBtn_() {//收益周期保存按钮
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20053,
                        min: this.RevenueCycleMin,
                        max: this.RevenueCycleMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.RevenueCycleMin = ''
                        this.RevenueCycleMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            MaxLossBtn_() {//最大回撤保存按钮
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20054,
                        min: this.MaxLossMin,
                        max: this.MaxLossMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.MaxLossMin = ''
                        this.MaxLossMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            SharpeRateBtn_() {//夏普比率保存按钮
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20055,
                        min: this.SharpeRateMin,
                        max: this.SharpeRateMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.SharpeRateMin = ''
                        this.SharpeRateMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            SortinoRateBtn_() {//索提诺比率保存
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20056,
                        min: this.SortinoRateMin,
                        max: this.SortinoRateMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.SortinoRateMin = ''
                        this.SortinoRateMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            CalmarRateBtn_() {//卡 玛 比 率
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20057,
                        min: this.CalmarRateMin,
                        max: this.CalmarRateMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.CalmarRateMin = ''
                        this.CalmarRateMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            YearlyWaveBtn_() {//年化波动
                this.$axios.post(
                    '/crm/acc_date/addCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        type: 20058,
                        min: this.YearlyWaveMin,
                        max: this.YearlyWaveMax
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.YearlyWaveMin = ''
                        this.YearlyWaveMax = ''
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            removeBtn(e) {//删除自定义
                // console.log(e)
                this.$axios.post(
                    '/crm/acc_date/delSearchCondition',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        scId: e.id
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.saveList()
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })
            },
            saveBtn() {
                window.location.reload()
            }


        },
        watch: {
            count(e) {
                if (e == this.res.length) {
                    this.logLevel = true
                } else {
                    false
                }
            },

        }

    };
</script>


// WEBPACK FOOTER //
// src/view/crm/analysis/index.vue